import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {FilterModule} from "../../shared/filters/filter.module";
import {CompanyService} from "./company.service";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import type {Company} from "./company";

@Component({
    selector: 'app-company-picker',
    imports: [
        FilterModule,
        ReactiveFormsModule
    ],
    templateUrl: './company-picker.component.html',
    styleUrl: './company-picker.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyPickerComponent implements OnInit{

  fc = new FormControl();
  companyService = inject(CompanyService);

  ngOnInit() {
    this.fc.setValue(this.companyService.activeCompany());
    this.fc.valueChanges.subscribe(company => {
      this.companyService.activeCompany.set(company);
    });
  }

  selectionChange(company: Company) {
    this.companyService.companySelectionChange.next(company);
  }
}
